var replace = (line: string, key: string | number): (string | JSX.Element)[] => {
  const leadingSpaces = line.match(/^ +/);
  const spaceElements = leadingSpaces
    ? Array(leadingSpaces[0].length)
        .fill(undefined)
        .map((_, j) => <span key={key + "_" + j}>&nbsp;</span>)
    : [];
  return [...spaceElements, line.trimStart()];
};

export const FormattedMultiline = ({ children }: { children: string }) => {
  const lines = children.split("\n");
  const result = lines.map((line, i) => [replace(line, i), <br key={i} />]).flat();

  result.pop();

  return <div>{result}</div>;
};
